import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_BatchScope_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_BATCHSCOPE_ID: { type: SearchProviderFieldType.number,  renderOptions: {columnName: 'WB MDSet Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: {}},
    BATCHSCOPE_ID: { type: SearchProviderFieldType.string, renderOptions: {columnName: 'Scope Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50} },
    BATCHSCOPE_NAME: { type: SearchProviderFieldType.string, renderOptions: {columnName: 'Scope Name', columnResourceName: 'colMDSetName', alignment: HorizAlignment.Left }, domainOptions: {maxLength: 50} },
    BATCH_PROCESS_ID: { type: SearchProviderFieldType.string, renderOptions: {columnName: 'Batch Process Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50} },
    BATCH_PROCESS_NAME: { type: SearchProviderFieldType.string, renderOptions: {columnName: 'Batch Process Name', columnResourceName: 'colMDSetName', alignment: HorizAlignment.Left }, domainOptions: {maxLength: 50} },
    MDSET_ID: { type: SearchProviderFieldType.string, renderOptions: {columnName: 'Master Data Set Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50} },
    MDSET_NAME: { type: SearchProviderFieldType.string, renderOptions: {columnName: 'Master Data Set Name', columnResourceName: 'colMDSetName', alignment: HorizAlignment.Left }, domainOptions: {maxLength: 50} },
    CREATED_DTTS: { type: SearchProviderFieldType.sapdate, renderOptions: {columnName: 'Created Date', columnResourceName: 'colCreateDt', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy" }, domainOptions: {} },
    MODIFIED_DTTS: {type: SearchProviderFieldType.sapdate, renderOptions: {columnName: 'Modified Date',columnResourceName: 'colModifiedDt', alignment: HorizAlignment.Center, dateFormat: "MM-dd-yy" }, domainOptions: {} }

};

const BatchScopeSearchProviderBasic: ISearchProvider = {

    keyFields:
        {
            id:    'WB_BATCHSCOPE_ID',
            id_ui: 'BATCHSCOPE_ID',
            name:  'BATCHSCOPE_NAME'
        },

    searchProviderFields: vUI_BatchScope_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_BatchScope_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                });
        })
    },
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_BatchScope_Search',
                this.searchProviderFields,
                [fieldName])


            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const BatchScopeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {},

    profileFilter: [
        {profileFilterName: 'Scope Id', searchProviderFieldId: 'BATCHSCOPE_ID', renderOptions: {}},
        {profileFilterName: 'Scope Name', searchProviderFieldId: 'BATCHSCOPE_NAME', renderOptions: {}},
        {profileFilterName: 'Process Name', searchProviderFieldId: 'BATCHPROCESS_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'BATCHSCOPE_ID', 'BATCHSCOPE_NAME', 'BATCH_PROCESS_ID', 'BATCH_PROCESS_NAME', 'MDSET_ID', 'MDSET_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: BatchScopeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const BatchScopeSearch: ISearch = {
    searchName: "Find Batch Scope",
    renderOptions: {},
    searchProfileIdDefault: "default",
    searchProfiles: [BatchScopeSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("BatchScopeBO", "BatchScope", BatchScopeSearch, "Batch Scope Search")

export {BatchScopeSearch}
